module.exports = __webpack_public_path__ + "img/72.d7776926.jpg";